import PropTypes from 'prop-types';

// Custom tooltip for better display
const CommitPieCustomTooltip = ({ active, payload }) => {
    if (active && payload?.length) {
        return (
            <div className="custom-tooltip" style={{ backgroundColor: '#fff', border: '1px solid #ccc', padding: '10px', borderRadius: '4px' }}>
                <p className="label" style={{ margin: 0, fontWeight: 'bold' }}>{`${payload[0].payload.developer}`}</p>
                <p className="desc" style={{ margin: 0 }}>Commits: {payload[0].value}</p>
            </div>
        );
    }
    return null;
};

CommitPieCustomTooltip.propTypes = {
    active: PropTypes.bool,
    payload: PropTypes.array
}

export default CommitPieCustomTooltip;